// extracted by mini-css-extract-plugin
export default {"payroll-summary-header":"PayrollSummaryReport_payroll-summary-header__h0xCN"};